import React from 'react';
import {XCircleIcon} from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import {authErrorsNl} from "./authErrorsNl.ts";

function FormError({message}) {
    const authErrors = authErrorsNl;

    let errorMessage: string;
    if (typeof message === 'string') {
        errorMessage = message;
    } else if (message?.code) {
        errorMessage = authErrors[message.code.slice(5)] || message.message || 'Something went wrong';
    } else {
        errorMessage = message?.message || 'Something went wrong';
    }

    errorMessage = errorMessage.replace('https://app.pocketcfo.io/reset-password', '/reset-password');

    return (
        <div role="alert" className="rounded-md bg-red-50 p-4">
            <div className="flex">
                <div className="flex-shrink-0">
                    <XCircleIcon aria-hidden="true" className="h-5 w-5 text-red-400"/>
                </div>
                <div className="ml-3">
                    <div className="text-sm font-medium text-red-800">
                        <ReactMarkdown
                            components={{
                                a: ({node, ...props}) => <a
                                    className="font-semibold text-red-800 hover:opacity-70 underline" {...props} />
                            }}
                        >
                            {errorMessage}
                        </ReactMarkdown>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FormError;
